import React from 'react';
import PropTypes from 'prop-types';
import styles from "../styles/components/StatusIndicator.module.css";

const StatusVariantIndicator = ({ character }) => {
	let colorClass = styles.gray;
	
	if('processing' in character){
		if(character.processing){
			colorClass = styles.gray;
		}else{
			if(character.success){
				if(character.has_3d){
					colorClass = styles.green;
				}
			}else{
				colorClass = styles.red;
			}
		}
	}else{
		// empty character
		colorClass = styles.yellow;
	}

	return (
		<div className={[styles.indicator, colorClass].join(' ')} />
	);
};

StatusVariantIndicator.propTypes = {
	character: PropTypes.any.isRequired,
};

export default StatusVariantIndicator;